<template>
  <AntFormItem :name="name" :label="label">
    <AntTooltip
      v-if="toolTip"
      :trigger="toolTipTrigger"
      :placement="toolTipPlacement"
    >
      <template #title>
        {{ toolTip }}
      </template>
      <component
        :is="`ant-${element}`"
        :type="inputType"
        v-bind="{
          ...$attrs,
          ...bindValue(name),
        }"
        @change="(e) => onChangeWithFormState(e, name)"
      />
    </AntTooltip>

    <component
      v-else
      :is="`ant-${element}`"
      :type="inputType"
      v-bind="{
        ...$attrs,
        ...bindValue(name),
      }"
      @change="(e) => onChangeWithFormState(e, name)"
    />
  </AntFormItem>
</template>

<script>
import { reactive } from 'vue'

import {
  Form as AntForm,
  Tooltip as AntTooltip,
  Input as AntInput,
  InputNumber as AntInputNumber,
  Select as AntSelect,
  Checkbox as AntCheckbox,
  Radio as AntRadio,
  Switch as AntSwitch,
  Button as AntButton,
} from 'ant-design-vue'

export default {
  name: 'FormItem',
  props: {
    formState: {
      type: Object,
      required: true,
    },
    element: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    label: String,
    inputType: String,
    toolTip: String,
    toolTipTrigger: String,
    toolTipPlacement: {
      type: String,
      default: 'right',
    },
    onChange: {
      type: Function,
      required: false,
    },
  },
  components: {
    AntTooltip,
    AntFormItem: AntForm.Item,
    AntInput,
    AntInputPassword: AntInput.Password,
    AntTextarea: AntInput.TextArea,
    AntInputNumber,
    AntSelect,
    AntCheckbox,
    AntCheckboxGroup: AntCheckbox.Group,
    AntRadio,
    AntRadioGroup: AntRadio.Group,
    AntSwitch,
    AntButton,
  },
  inheritAttrs: false,
  setup(props) {
    const formState = reactive(props.formState)

    const bindValue = key => ({
      ...(['input', 'input-number', 'input-password', 'textarea', 'select', 'radio', 'radio-group', 'checkbox-group'].includes(props.element) && { value: formState[key] }),
      ...(['switch', 'checkbox'].includes(props.element) && { checked: formState[key] }),
    })

    const onChangeWithFormState = (e, key) => {
      if (['input', 'textarea', 'radio'].includes(props.element)) formState[key] = e.target.value.trim()
      if (['input-password', 'radio-group'].includes(props.element)) formState[key] = e.target.value
      if (['checkbox'].includes(props.element)) formState[key] = e.target.checked
      if (['input-number', 'select', 'switch', 'checkbox-group'].includes(props.element)) formState[key] = e
      if (props.onChange) props.onChange(e)
    }

    return {
      bindValue,
      onChangeWithFormState,
    }
  },
}
</script>

<style scoped>
.ant-input-number {
  width: 100%;
}
</style>
